import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { BrowseService } from "core/browse.service";

@Injectable({ providedIn: "root" })
export class RelatedWorkspacesResolver implements Resolve<stages.workspace.Workspace[]> {
	constructor(private browseService: BrowseService) {}

	async resolve(route: ActivatedRouteSnapshot): Promise<stages.workspace.Workspace[]> {
		return this.browseService.getRelatedWorkspaces(
			route.paramMap.get("workspaceId")!,
			route.paramMap.get("processVersion")!,
		);
	}
}
